import React, { useEffect, useState } from 'react'
import { motion } from "framer-motion"
import '../components/Styles/home.css'
import '../components/Styles/PrivateOffice.css'
import xm1 from '../assets/images/space.png'
import o1 from '../assets/images/o1.png'
import o2 from '../assets/images/o2.png'
import o3 from '../assets/images/o3.png'
import ep from '../assets/images/ep.png'
import ov1aa from '../assets/images/ov1aa.png'
import ov1bb from '../assets/images/ov1bb.png'
import ov1cc from '../assets/images/ov1cc.png'
import ov1dd from '../assets/images/ov1dd.png'
import ov1ee from '../assets/images/ov1ee.png'
import ov1ff from '../assets/images/ov1ff.png'

import {Helmet}from"react-helmet";

import AOS from 'aos';
import 'aos/dist/aos.css';
import Slide from './Slide'





/* ✅ CTA + WHY icons (NEW) */
const IconCalendar = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3v3M17 3v3M4.5 8.5h15"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M6 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M8 12h3M8 15h3M14 12h2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

/* renamed to avoid conflict with IconPhone above */
const IconCall = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3h4l2 5-2 1c1 2.8 3.2 5 6 6l1-2 5 2v4c0 1-1 2-2 2C10 21 3 14 3 5c0-1 1-2 2-2h2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);



const PrivateOffices = () => {
  const [openIndex, setOpenIndex] = useState(null);

   useEffect(() => {
    AOS.init();
  }, []);



  return (
    <div>

          <Helmet>
      
      <title>Pricing Plans for Xceed Office CRM | Affordable Plans & Free Trial</title>
      <meta name="description" content="Compare Xceed Office CRM pricing plans for professionals and teams. Explore features, scalable plans, and start with a free trial today."/>
      < meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <meta charset="UTF-8"/>
      
      </Helmet>
      {/* 🔶 HERO SECTION */}
      <section className="p_main2">
        <div className="p_main_sec">
          <h1>
           Private Office


            <br /> 
<span style={{ color: "#EEBD2B" }}>Fully Serviced.</span>
          </h1>

          <p style={{color:"#A39E8F"}}>            Move into a fully furnished, Class A private office with executive-
grade infrastructure, hospitality, and the flexibility modern
businesses require.
 </p>
<div style={{display:"flex"}}>
        <button>
                    <a href="https://calendly.com/xceedoffice-info/new-meeting">Schedule a Private Tour</a>    </button>       <a href="tel:346-502-2552">
  <button
    style={{
      background: "#0D0D0D",
      color: "#EEBD2B",
      opacity: 1,
      alignItems: "center",
      display: "flex",
      cursor: "pointer",
    }}
  >
    <span className="cta__btnIcon">
      <IconCall />
    </span>
    <span>&nbsp; Call Now</span>
  </button>
</a>
</div>
        </div>
      </section>


  <section class="included-section">
  <div class="included-header">
    <h2>What's Included</h2>
    <p>
      Every private office at Xceed comes fully equipped with the services and amenities
      executive teams expect.
    </p>
  </div>

  <div class="included-grid">
    <div class="included-card">
      <div class="icon"><img src={ov1aa} alt="" /></div>
      <h3>Class A Address</h3>
      <p>Establish your business at a prestigious Houston address that signals credibility and stature.</p>
    </div>

    <div class="included-card">
      <div class="icon"><img src={ov1bb} alt="" /></div>
      <h3>Secure & Private</h3>
      <p>Lockable offices, 24/7 secure building access, and dedicated infrastructure for confidential work.</p>
    </div>

    <div class="included-card">
      <div class="icon"><img src={ov1cc} alt="" /></div>
      <h3>Enterprise Infrastructure</h3>
      <p>High-speed business internet, professional phone systems, and full IT support included.</p>
    </div>

    <div class="included-card">
      <div class="icon"><img src={ov1dd} alt="" /></div>
      <h3>Premium Amenities</h3>
      <p>Curated business lounges, fully stocked kitchens, and concierge-level hospitality every day.</p>
    </div>

    <div class="included-card">
      <div class="icon"><img src={ov1ee} alt="" /></div>
      <h3>Meeting Rooms</h3>
      <p>Access to executive boardrooms and conference suites equipped with the latest AV technology.</p>
    </div>

    <div class="included-card">
      <div class="icon"><img src={ov1ff} alt="" /></div>
      <h3>Move-In Ready</h3>
      <p>Fully furnished offices designed for immediate occupancy — no buildout, no infrastructure investment.</p>
    </div>
  </div>
</section>
<section className="private-office-section">
  <div className="private-office-header">
    <h2>Choose Your Private Office</h2>
    <p>
      From executive suites to fully equipped team rooms — designed for every
      stage of your business.
    </p>
  </div>

  <div className="office-grid">
    {/* Card 1 */}
    <div className="office-card">
      <div className="office-icon"><img src={o1} alt="" /></div>

      <h3>Essential Offices</h3>
      <span>1–2 PEOPLE</span>

      <p className="office-desc">
        A refined private office designed for executives and small teams who
        require a quiet, professional environment.
      </p>

      <div className="price">
        $850<small>/ month</small>
      </div>

      <ul>
        <li>Furnished private office</li>
        <li>Lockable door & 24/7 access</li>
        <li>High-speed business internet</li>
        <li>5 hours meeting room/month</li>
        <li>Mail & package handling</li>
        <li>Business lounge access</li>
      </ul>
      <a href="https://xceed.nexudus.site/Xceed/checkout/add-ons?start=2026-07-07T19%3A00%3A00.000-05%3A00&plan_id=1415392287&contract=eyJJc3N1ZWRCeUlkIjoxNDIxMDEwMzA5LCJUYXJpZmZJZCI6MTQxNTM5MjI4NywiU3RhcnREYXRlIjoiMjAyNi0wNy0wOFQwMDowMDowMC4wMDBaIiwiSWQiOjAsIkNvd29ya2VyUHJvZHVjdHMiOltdfQ%3D%3D">
      <button>Reserve This Office</button>
      </a>
    </div>

    {/* Card 2 */}
    <div className="office-card popular">
      <div className="badge">MOST POPULAR</div>

      <div className="office-icon"><img src={o2} alt="" /></div>

      <h3>Signature Offices</h3>
      <span>2–3 PEOPLE</span>

      <p className="office-desc">
        A premium corner office with expansive views, ideal for senior
        leadership and growing professional teams.
      </p>

      <div className="price">
      $2,200 <small>/ month</small>
      </div>

      <ul>
        <li>Premium corner suite with views</li>
        <li>Executive-grade furnishings</li>
        <li>Dedicated business phone line</li>
        <li>10 hours meeting room/month</li>
        <li>Priority concierge service</li>
        <li>Reserved guest parking</li>
      </ul>
      <a href="https://xceed.nexudus.site/Xceed/checkout/add-ons?start=2026-07-07T19%3A00%3A00.000-05%3A00&plan_id=1415392287&contract=eyJJc3N1ZWRCeUlkIjoxNDIxMDEwMzA5LCJUYXJpZmZJZCI6MTQxNTM5MjI4NywiU3RhcnREYXRlIjoiMjAyNi0wNy0wOFQwMDowMDowMC4wMDBaIiwiSWQiOjAsIkNvd29ya2VyUHJvZHVjdHMiOltdfQ%3D%3D">
      <button>Reserve This Office</button>
      </a>
    </div>

    {/* Card 3 */}
    <div className="office-card">
      <div className="office-icon"><img src={o3} alt="" /></div>

      <h3>Chairman's Suites</h3>
      <span>4–8 PEOPLE</span>

      <p className="office-desc">
        A spacious private suite tailored for established teams that require
        collaborative space and full privacy.
      </p>

      <div className="price">
      $4,500 <small>/ month</small>
      </div>

      <ul>
        <li>Large enclosed team suite</li>
        <li>Custom branding options</li>
        <li>20 hours meeting room/month</li>
        <li>Dedicated reception support</li>
        <li>Private storage cabinets</li>
        <li>Catered meeting service</li>
      </ul>
       <a href="https://xceed.nexudus.site/Xceed/checkout/add-ons?start=2026-07-07T19%3A00%3A00.000-05%3A00&plan_id=1415392290&contract=eyJJc3N1ZWRCeUlkIjoxNDIxMDEwMzA5LCJUYXJpZmZJZCI6MTQxNTM5MjI5MCwiU3RhcnREYXRlIjoiMjAyNi0wNy0wOFQwMDowMDowMC4wMDBaIiwiSWQiOjAsIkNvd29ya2VyUHJvZHVjdHMiOltdfQ%3D%3D">
      <button>Reserve This Office</button>
      </a>
    </div>
  </div>
</section>

   
 <section className="why-choose-section">
  <div className="why-choose-container">
    
    {/* Left Image */}
    <div className="why-choose-image">
      <img
        src={ep}
        alt="Private Office Workspace"
      />
    </div>

    {/* Right Content */}
    <div className="why-choose-content">
      <h2>Why Choose a Xceed Private Office</h2>

      <p>
        Skip the cost and complexity of a traditional lease. Move into a
        refined workspace that reflects your brand and supports your team
        from day one.
      </p>

      <ul className="benefits-list">
        <li>No buildout cost or capital expenditure</li>
        <li>No long-term lease commitment</li>
        <li>Flexible terms tailored to your business</li>
        <li>Class A address & executive image</li>
        <li>Full-service hospitality team on-site</li>
        <li>Scalable as your team grows</li>
      </ul>
    </div>

  </div>
</section>   

 
 

      {/* ✅ CTA SECTION (ADDED) */}
      <section  className="cta">
        <div className="cta__wrap">
          <h2 className="cta__title">
            Ready to Elevate Your <br />
            <span>Business Presence?</span>
          </h2>

          <p className="cta__sub">
            Join professionals who trust Xceed Office for their workspace <br />
            needs.
          </p>

          <div className="cta__actions">
            <button className="cta__btn cta__btn--primary" type="button">
              <span className="cta__btnIcon"><IconCalendar /></span>
                            <a href="https://calendly.com/xceedoffice-info/new-meeting?month=2026-03">Schedule a Tour</a> <span className="cta__arrow">→</span>
            </button>

            <button className="cta__btn cta__btn--ghost" type="button">
             <a href="tel:+1 (281) 270-6431">Call Now</a>  
            </button>
          </div>

        </div>
      </section>


    </div>
  )
}

export default PrivateOffices